import React from 'react';
import './SkeletonLoader.css';

// Individual skeleton card matching subject-card dimensions
export const SkeletonCard = () => {
  return (
    <div className="skeleton-card">
      {/* Header section with icon and title */}
      <div className="skeleton-header">
        <div className="skeleton-icon"></div>
        <div className="skeleton-title"></div>
      </div>

      {/* Performance section */}
      <div className="skeleton-performance">
        {/* Progress bar */}
        <div className="skeleton-progress-bar">
          <div className="skeleton-progress-fill"></div>
        </div>
        
        {/* Performance stats */}
        <div className="skeleton-stats">
          <div className="skeleton-label"></div>
          <div className="skeleton-value">
            <div className="skeleton-percentage"></div>
            <div className="skeleton-check-icon"></div>
          </div>
        </div>
      </div>

      {/* Button */}
      <div className="skeleton-button"></div>
    </div>
  );
};

// Main skeleton loader with multiple cards
export const DashboardSkeleton = ({ cardCount = 3 }) => {
  return (
    <div className='dashboard-home'>
      <div className='dashboard-header'>
        <div className='title-section'>
          <div className="skeleton-chart-icon"></div>
          <div className="skeleton-dashboard-title"></div>
        </div>
      </div>

      <div className='subjects-grid'>
        {Array.from({ length: cardCount }, (_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    </div>
  );
};

export default DashboardSkeleton;
